module.exports = __webpack_public_path__ + "img/referral.3b843d68.svg";